module.exports = "/assets/LTRM-e48643f1191d300e205ebe5875ca2e79.png";